import { createAsyncThunk } from '@reduxjs/toolkit';

import { AccountService } from 'api';

export const getSummary = createAsyncThunk(
	'statement/getSummary',
	async (params: { startDate: string; endDate: string }) => {
		return await AccountService.getSummary(params);
	},
);
